import axiosInstance from "./axiosInstance";

class LandingApi {
  static async getPlansList() {
    try {
      const response = await axiosInstance.get(`/plans/list`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default LandingApi;
